module.exports = __webpack_public_path__ + "img/Security4_CN@3x.394c40f5.png";